'use client';
/**
 * Выполняет проверку того, что `subject` является функцией.
 *
 * @typeParam R - Тип функции с произвольной сигнатурой.
 * @param subject - Субъект проверки произвольного типа.
 *
 * @primaryExample
 * isFunction(() => {}) // true
 * isFunction(function(){}) // true
 *
 * @stable
 * */ const isFunction = (subject)=>typeof subject === 'function';

export { isFunction };
//# sourceMappingURL=isFunction.js.map
